export default "__VITE_ASSET__5XH52xpU__"